<template>
    <div class="page-container lsp-list-container">
        <div>
            <b-tabs v-model="tabIndex" class="ft-tabs">
                <b-tab title="Today's Supply" id="today_supply" @click="handleOnClickTab" active>
                    <lsp-supply-list-container />
                </b-tab>
                <b-tab title="My Loads" id="my_loads" @click="handleOnClickTab" :active="$route.query.tab == 'loads'">
                    <lsp-loads-container @mx-track="trackMixpanelEvent" />
                </b-tab>
            </b-tabs>
        </div>
        <div class="ft-btn-block fixed">
            <AddLoadFAB @click.native="handleAddLoad" />
        </div>
    </div>
</template>

<script>
import LspSupplyListContainer from './LspSupplyLisContainer.vue'
import LspLoadsContainer from './LspLoadsContainer.vue'
import AddLoadFAB from '../components/AddLoadFAB.vue'
// import LspDemandDetailCard from '../components/LspDemandDetailCard.vue'

// import NoLoadsLsp from '../components/NoLoadsLsp.vue';
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL

import {identify, MX_TRACK_LSP} from '../utils/Mixpanel.js'
const Hotjar = require('../utils/Hotjar.js')
import config from '../config/config.js'

export default {
    components: {
        LspSupplyListContainer,
        LspLoadsContainer,
        AddLoadFAB,

        // NoLoadsLsp
    },
    data() {
        return {
            supplyList: {},
            demandDetails: [],
            showPageLoader: false,
            pagination: {
                total: 0,
                pageSize: 1,
                currentPage: 0,
                searchAfter: null
            },
            pageSize: 1,
            currentPage: 0,
            activeTab: "Today's Supply",
            tabIndex: 0
        }
    },
    methods: {
        handleAddLoad() {
            this.$store.commit('setLspLoadDetail', {})
            this.$router.push({ name: 'lsp_add', params: { lang: this.$route.params.lang, id: this.$route.params.id  } })
            this.trackMixpanelEvent('Click_on_Add_Load', {source_page: this.activeTab})
        },
        getMoreDemandList(isVisible) {
            if (isVisible && (this.demandDetails.length < this.pagination.total)) {
                this.currentPage += 1;
                this.getDemadDetails()
            }
        },
        async getSupplyList() {
            try {
                const {data} = await axios.get(`${API_BASE_URL}/supply/list/?page_number=${this.currentPage}&page_size=${this.pageSize}`)
                console.log(data)
            } catch (error) {
                console.log(error)
            }
        },
        async getDemadDetails(isDefault = false) {
            this.showPageLoader = true
            try {
                const pageNo = isDefault ? 0 : this.currentPage;
                const {data} = await axios.get(`${API_BASE_URL}/demand/loads/${this.$route.params.id}?page_number=${pageNo}&page_size=${this.pageSize}`)
                this.pagination = data.pagination
                this.demandDetails = isDefault ? data.value : [...this.demandDetails, ...data.value]
                this.$store.commit('updateLspDemandList', this.demandDetails)
                identify(this.$route.params.id)

                this.trackMixpanelEvent(config.MIXPANEL_EVENTS.LSP_PAGE_LOAD)

            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        },
        handleOnClickTab(data) {
            console.log(data)
            const tab = data.target
            this.activeTab = tab.innerText
            const event = tab.innerText == "My Loads" ? 'Click_My_Loads' : 'Click_Todays_Supply'
            this.trackMixpanelEvent(event)
        },
        trackMixpanelEvent(event, data = {}) {
            const demandDetails = this.$store.getters.getDemandDetails.value
            const lspList = this.$store.getters.getLspDemandList
            const mx_prop = {
                user_name: demandDetails.name,
                phone_number: demandDetails.phone,
                user_id: demandDetails.demand_id,
                loads_added_today: lspList.length
            }
            MX_TRACK_LSP(event, {...mx_prop, ...data})
            Hotjar.IDENTIFY_LSP_APP(this, demandDetails.name, {...mx_prop, ...data});
        },
        cacheId() {
            localStorage.setItem('lsp_id', this.$route.params.id)
        }
    },
    mounted() {
        // this.getSupplyList();
        // this.getDemadDetails();
        this.cacheId();
        this.tabIndex = this.$route.query.tab == 'loads' ? 1 : 0
    }
}
</script>

<style lang="scss">
body {
    background-color: #FFF;
}
.lsp-list-container {
    margin-top: 60px;
    .ft-route-details {
        .ft-route-details {
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            letter-spacing: 0.15px;
            color: #1F1F1F;
        }

    }
    .vehicle-details {
        span {
            padding-left: 1rem;
        }
    }

    .demand-share-btn {
        padding: 1px !important;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 0.25px;
        color: #707070;
    }

    .tabs {
    .tab-content {
        height: 100vh;
        background-color: #F5F5F5;
    }

    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background-color: transparent;
        border: none;
        border-bottom: 3px solid #1F1F1F;
    }

    .nav-tabs {
        padding: 0.57rem 1rem 0;
        box-shadow: 0px 0.25px 0.5px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.16);

        .nav-item {
            a {
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                letter-spacing: 0.1px;
                color: #474747;
            }
        }
    }
}

   
}

//Tabs

</style>
